import React from 'react';
import Icon from '../../../components/AppIcon';

const BudgetOverviewCard = ({ title, value, subtitle, icon, iconColor, trend, trendValue }) => {
  const getTrendColor = () => {
    if (!trend) return 'text-muted-foreground';
    if (trend === 'positive') return 'text-success';
    if (trend === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (!trend) return 'Minus';
    if (trend === 'positive') return 'TrendingUp';
    if (trend === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 transition-smooth hover:shadow-md">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-md">
          <Icon name={icon} size={24} color={iconColor || 'var(--color-primary)'} />
        </div>
        {trend && trendValue && (
          <div className={`flex items-center gap-1 ${getTrendColor()}`}>
            <Icon name={getTrendIcon()} size={16} color="currentColor" />
            <span className="data-text text-sm font-medium">{trendValue}</span>
          </div>
        )}
      </div>
      <h3 className="caption text-sm text-muted-foreground mb-2">{title}</h3>
      <p className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-1">{value}</p>
      {subtitle && (
        <p className="caption text-xs text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default BudgetOverviewCard;